var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.887 13.7892C19.9223 17.6079 23.2373 18.8789 23.2739 18.8951C23.2458 18.9845 22.7443 20.7062 21.5276 22.4841C20.4758 24.0214 19.384 25.5529 17.6646 25.585C15.975 25.6159 15.4316 24.5828 13.4997 24.5828C11.5684 24.5828 10.9649 25.5529 9.36529 25.6159C7.70535 25.6789 6.44131 23.9533 5.38079 22.422C3.21385 19.289 1.55777 13.5688 3.78138 9.70757C4.88598 7.79007 6.86035 6.57599 9.00312 6.54471C10.633 6.51363 12.1715 7.64118 13.1678 7.64118C14.1635 7.64118 16.0331 6.28512 17.9985 6.48418C18.8214 6.51851 21.1309 6.81649 22.6139 8.98749C22.4947 9.06163 19.8583 10.5964 19.887 13.7892M16.7115 4.41169C17.5927 3.34509 18.1858 1.85984 18.0241 0.382507C16.7538 0.433492 15.2177 1.22893 14.3067 2.29513C13.4901 3.23905 12.7751 4.7503 12.9679 6.19838C14.3839 6.30807 15.8301 5.47891 16.7115 4.41169",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.0c95a80f34ae732dbf1f2f0a7325a347.svg";
export { ForwardRef as ReactComponent };